module.exports = __webpack_public_path__ + "img/tabletennis.e11038ae.svg";